export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
